import { NgModule } from "@angular/core";
import { sanitizeHtmlPipe } from "src/app/shared/pipes/htmlsan.pipe";

@NgModule({
  declarations: [sanitizeHtmlPipe],
  exports: [sanitizeHtmlPipe],
})
export class SanitizeHtmlPipeModule {}
